import {useState,useEffect} from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate,useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const Permissions = () => {

    const { id } = useParams();
    const {readData: getMenus} = useEntityCrud('Privileges/getMenus');
    const {readData: getOldPermissions} = useEntityCrud('Privileges/getPrivileges?roleId=' + id);
    const {addData: insert} = useEntityCrud('Privileges/setPrivileges');
    const [menus,setMenus] = useState([]);
    const [permissions,setPermissions] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        getMenus().then(({data}) => {
            if(data.status)
                setMenus(data.result);
        });
        getOldPermissions().then(({data}) => {
            if(data.status && data.result.privilegesMap && data.result.privilegesMap.length > 0)
                setPermissions(data.result.privilegesMap);
        })
    },[])

    const handleBack = () => {
        navigate('/roles',{replace: true});
    }

    const handlePermissions = (operation,menuId,state) => {
        const item = permissions.find(permission => permission.menuId == menuId);
        if(item){
            item.crudMap[`${operation}Value`] = state ? 1 : 0;
            const getPermissions = permissions.filter(permission => permission.menuId != menuId);
            setPermissions([...getPermissions,item])
        }else{
            const crudMap = {
                createValue: 0,
                readValue: 0,
                updateValue: 0,
                deleteValue: 0
            };
            crudMap[`${operation}Value`] = state ? 1 : 0;
            const newItem = {
                menuId,
                crudMap
            };
            setPermissions([...permissions,newItem]);
        }
    }

    useEffect(() => {
        console.log(permissions);
    },[permissions])

    const submitData = () => {
        const postedData = {
            roleId: id,
            privilegesMap: permissions
        };
        insert(postedData).then(({data}) => {
            if(data.status)
                toast.success('اطلاعات سطح دسترسی در سیستم ذخیره شد');
        });
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">سطح دسترسی ها</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <div className="row">
                    {menus.map(menu => (
                        <div className="col-md-3 mb-3">
                            <h5>{menu.title}</h5>
                            <div className="form-check">
                                <input className="form-check-input" onChange={e => handlePermissions('create',menu.id,e.target.checked)} checked={permissions.find(permission => permission.menuId == menu.id)?.crudMap.createValue == 1} type="checkbox" id={`op-create-${menu.id}`} />
                                <label className="form-check-label" for={`op-create-${menu.id}`}>ایجاد</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" onChange={e => handlePermissions('read',menu.id,e.target.checked)} checked={permissions.find(permission => permission.menuId == menu.id)?.crudMap.readValue == 1} type="checkbox" id={`op-read-${menu.id}`} />
                                <label className="form-check-label" for={`op-read-${menu.id}`}>مشاهده</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" onChange={e => handlePermissions('update',menu.id,e.target.checked)} checked={permissions.find(permission => permission.menuId == menu.id)?.crudMap.updateValue == 1} type="checkbox" id={`op-update-${menu.id}`} />
                                <label className="form-check-label" for={`op-update-${menu.id}`}>به روزرسانی</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" onChange={e => handlePermissions('delete',menu.id,e.target.checked)} checked={permissions.find(permission => permission.menuId == menu.id)?.crudMap.deleteValue == 1} type="checkbox" id={`op-delete-${menu.id}`} />
                                <label className="form-check-label" for={`op-delete-${menu.id}`}>حذف</label>
                            </div>
                            <hr />
                        </div>
                    ))}
                </div>
                <button className="btn btn-success mt-1" onClick={submitData}>ثبت و ذخیره</button>
            </div>
        </div>
    )
}

export default Permissions;